module.exports = __webpack_public_path__ + "img/collection-star.2719a31c.svg";